import { message, Modal } from "antd";
import { openPicker } from "../components/CategoriesPickerTree";
import { ICategoryAddCallback, api } from "./index";
import { getSpaceIdByRootId, moveTips } from "../util";
import { lang } from "../context";
import events from "../context/events";
import { ActionFnEnum, ActionType } from "../types";
import { folderTypeEnum } from "../config/permissions.config";
import { getPageMenuLogId } from "./utils";
import { analysisLog } from "@/utils/logAnalytics";
const Move: ICategoryAddCallback = (props, isAllow, isTeam) => {
  function freshLeftTreeByFolderById(id: string) {
    events.emit("freshLeftTreeByFolderById", id);
  }
  const { data, reload, setData, originId = "" } = props;
  const defaultNav =
    data.type === 3 // 判断是否为组空间
      ? [
          {
            name: data.full_name.split("$@$")?.[0],
            id: data?.space_id,
            icon: "iconapp_btn_folder",
            level: 1,
            isLeaf: false,
            type: 3,
            disabled: false,
            selectable: true
          }
        ]
      : null;
  return [
    {
      children: lang("ctx.move.title"),
      icon: "pc_yundoc_move",
      splitCode: 2,
      tip: "将文档或文件夹移动到新的位置。仅文档和文件夹的所有者或可管理协作者可移动。",
      callbackOrModal: () => {
        openPicker({
          reload,
          defaultNav,
          title: data.title || data.name || "无标题",
          isTeam: isTeam,
          originId,
          isGroupSpace: data.type === 3 ? true : false,
          callback: (data, close) => {
            // data.id &&
            //     api.categories.move(props.data.id, data.id).then((data) => {
            //         if (data) {
            //             freshLeftTreeByFolderById(data.id);
            //             reload();
            //             message.success(lang('common.success'));
            //         } else {
            //             message.error(lang('common.fail'));
            //         }
            //         close();
            //         // props.remove();
            //     });
            // console.log(data, "lalal111");
            const tip = moveTips(props.data, data, isTeam);
            Modal.confirm({
              // @ts-ignore
              content: lang(tip, { name: data.name }),
              title: lang("ctx.move.tips.title"),
              // content:
              //     '移动后将取消原文件夹协作者的共享，并重新共享给目标文件夹的协作者。',
              cancelText: lang("common.cancel"),
              okText: lang("common.confirm"),
              onOk: () => {
                if (!data?.id) return;

                const useBatchMoveToDtoList = {
                  batchMoveInfos: [
                    {
                      fromType:
                        props.data.type === folderTypeEnum.SHARE ||
                        props.data.type === folderTypeEnum.GROUP
                          ? folderTypeEnum.SHARE
                          : folderTypeEnum.MY,
                      targetId: props.data.id,
                      targetType: 4
                    }
                  ],
                  toId: data.id,
                  toType: data.type === 3 ? 12 : data.type
                };
                const logId = getPageMenuLogId("doMove");
                console.log(
                  logId,
                  props.data.type?.toString() || "",
                  data.type?.toString() || "",
                  "1",
                  "click"
                );
                analysisLog(
                  "xtbg_jzb_joyspace_home_1676548210761",
                  logId,
                  props.data.type?.toString() || "",
                  data.type?.toString() || "",
                  "1",
                  "click"
                );
                api.batch.moveTo(useBatchMoveToDtoList as any).then((data1) => {
                  if (data1?.data) {
                    const res = getSpaceIdByRootId(originId, data.id);
                    if (!res) {
                      events.emit("deleteFolderById", props.data.id, data.id);
                      setData({
                        type: ActionFnEnum.REMOVE,
                        id: props.data.id,
                        actionType: ActionType.Folder
                      } as any);
                    }
                    message.success(data1?.data || lang("common.success"));

                    events.emit("list.check");
                  } else {
                    message.error(data1?.status || lang("common.fail"));
                  }
                  close();
                });
              }
            });
          },
          selectArray: [
            {
              id: props.data.id,
              rootId: props.data.space_id,
              type: "folder"
            }
          ],
          treeFreshFunction: (data: any) => {
            freshLeftTreeByFolderById(data);
          }
        });
      },
      isAllow,
      type: "move"
    }
  ];
};

export default Move;
